import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fmtDate } from "@/components/admin/format";

const LABEL = {
  first_admin_created: "created the first admin account",
  user_added: "added",
  user_changed: "changed",
  user_removed: "removed",
  reset_link_made: "made a setup/reset link for",
  password_set: "set their password",
  password_changed: "changed their password",
  settings_changed: "changed settings",
  setting_reset: "reset setting",
  key_set: "set API key",
  key_cleared: "cleared API key",
  meeting_deleted: "deleted meeting",
  signed_out_everywhere: "signed out of all their devices",
};

const detail = (e) => {
  if (!e.detail) return "";
  return Object.entries(e.detail).map(([k, v]) => (Array.isArray(v) ? `${k}: ${v[0]} → ${v[1]}` : `${k}: ${v}`)).join(" · ");
};

// Who changed what in Admin and accounts. Never meeting content, never key values.
export const ActivityPanel = () => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/admin/audit").then(({ data }) => setItems(data)).catch((e) => toast.error(errMsg(e)));
  }, []);
  return (
    <div className="border border-[var(--o-border)]" data-testid="activity-panel">
      <div className="px-5 py-4 border-b border-[var(--o-border)]">
        <h2 className="font-display text-base md:text-lg font-bold">Activity</h2>
        <p className="text-xs text-[var(--o-muted2)] mt-1">Account and Admin changes, newest first. Key values and meeting content are never recorded.</p>
      </div>
      {!items && <div className="h-24 shimmer m-5" />}
      {items?.length === 0 && <p className="px-5 py-4 text-sm text-[var(--o-muted3)]">Nothing yet.</p>}
      {items?.map((e, i) => (
        <div key={i} className="grid sm:grid-cols-[140px_1fr] gap-x-4 gap-y-0.5 px-5 py-2.5 border-b border-[var(--o-border-soft)] last:border-b-0 text-sm" data-testid="activity-row">
          <span className="font-mono text-[11px] text-[var(--o-muted3)]" title={e.at}>{fmtDate(e.at)}</span>
          <span className="min-w-0">
            <span className="font-semibold">{e.actor || "someone"}</span> <span className="text-[var(--o-muted)]">{LABEL[e.action] || e.action}</span>{" "}
            {e.target && <span className="font-mono text-xs">{e.target}</span>}
            {e.detail && <span className="block font-mono text-[11px] text-[var(--o-muted2)] truncate">{detail(e)}</span>}
          </span>
        </div>
      ))}
    </div>
  );
};
